import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  HeroChemical,
  ProgramAndDigest,
  DeliverablesChemical,
  WinWinChemical,
  WhyTNO,
  MetricsChemical,
  CTAChemical,
} from './components';

const LandingMediaKitChemical = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <HeroChemical themeMode={themeMode} />
      </Container>
      <Container>
        <ProgramAndDigest />
      </Container>
      <Container>
        <WinWinChemical />
      </Container>
      <Container>
        <DeliverablesChemical />
      </Container>
      <Container>
        <WhyTNO />
      </Container>
      <Container>
        <MetricsChemical />
      </Container>
      <Container>
        <CTAChemical />
      </Container>
    </Box>
  );
};

LandingMediaKitChemical.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitChemical;
